// extracted by mini-css-extract-plugin
export var cancelButton = "_me-5";
export var content = "_me-3";
export var createButton = "_me-6";
export var drawerContainer = "_me-0";
export var footer = "_me-2";
export var header = "_me-1";
export var orderFormColumn = "_me-4";